<template>
  <!-- <div class="visible" v-if="true"> -->
  <div class="visible">
    <button @click="prev" :class="{'active': prevIsActive}" data-obblur='prevent'>{{ $t('common.back') }}</button>
    <button @click="next" :class="{'active': nextIsActive}" data-obblur='prevent'>{{ $t('common.forward') }}</button>
  </div>
</template>

<script>

export default {
  props: {
    elementsId: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentIndex: 0,
    };
  },
  computed: {
    prevIsActive() {
      return this.elementsId[this.currentIndex - 1];
    },
    nextIsActive() {
      return this.elementsId[this.currentIndex + 1];
    },
  },
  methods: {
    prev() {
      if (!this.prevIsActive) return;

      this.currentIndex--;
      document.getElementById(this.getElementByIndex()).focus();

      this.scrollOnFocus();
    },
    next(lastChar) {
      if (!this.nextIsActive) return;

      this.currentIndex++;
      const el = document.getElementById(this.getElementByIndex());
      el.focus();

      if (lastChar) {
        el.value = lastChar;
        el.dispatchEvent(new Event('input'));
      }

      this.scrollOnFocus();
    },
    getElementByIndex() {
      return this.elementsId[this.currentIndex];
    },
    setCurrentIndex(id) {
      this.currentIndex = this.elementsId.findIndex(el => el === id);
    },
    async scrollOnFocus() {
      if (!this.$parent.IS_MOBILE_ONLY || !this.$parent.someInputFocused) return;

      await this.$nextTick();

      const wrapperId = this.currentIndex === 2 ? `wrapper-${this.elementsId[1]}` : `wrapper-${this.getElementByIndex()}`;
      const offsetLeft = document.getElementById(wrapperId).offsetLeft - 30;

      this.$parent.$refs.cardFieldset.scrollLeft = offsetLeft;
    },
  },
};
</script>
